import React, { createContext, useContext, useMemo } from 'react';

const defaultMetaOverlay = {
  show: false,
  timestamp: null,
  formattedTime: '',
  statusIcon: null,
  attribution: null,
};

const MessageBubbleContext = createContext({
  isMine: false,
  layoutProfile: null,
  metaOverlay: defaultMetaOverlay,
});

export function MessageBubbleProvider({
  isMine = false,
  layoutProfile = null,
  metaOverlay = defaultMetaOverlay,
  children,
}) {
  const value = useMemo(
    () => ({
      isMine: Boolean(isMine),
      layoutProfile,
      metaOverlay: metaOverlay || defaultMetaOverlay,
    }),
    [isMine, layoutProfile, metaOverlay]
  );

  return (
    <MessageBubbleContext.Provider value={value}>{children}</MessageBubbleContext.Provider>
  );
}

export function useMessageBubbleContext() {
  return useContext(MessageBubbleContext);
}

export default MessageBubbleContext;
